export const setActivePatient = payload => ({
	type: 'SET_PATIENT_INFO',
	payload
})

export const updatePathologyPatient = payload => ({
	type: 'UPDATE_PATHOLOGY_PATIENT',
	payload
})

export const updatePlanPatient = payload => ({
	type: 'UPDATE_PLAN_PATIENT',
	payload
})

export const removeActivePatient = () => ({
	type: 'RESET_PATIENT_INFO'
})
